import { Context, createContext, useContext } from 'react';
import { IListInvoice } from '~/types/invoice';

interface IInvoiceListContext {
  listIds: Array<IListInvoice['invoice_uuid']>;
  listData: Record<IListInvoice['invoice_uuid'], IListInvoice>;
  onOpenDeleteInvoiceModal(invoiceUuid: string): void;
  onOpenViewInvoiceModal(invoiceUuid: string): void;
  onEditInvoice(invoiceUuid: string): void;
  onEditListInvoice(invoiceUuid: string, invoiceUpdates: Partial<IListInvoice>): void;
  onCloneInvoice(invoiceUuid: string): void;
  handleStatusChange(qsKey: string, selectedValue: string): void;
  maxListItems: number | null;
  renderFilters: boolean;
}

export const InvoiceListContext: Context<IInvoiceListContext> = createContext(
  {} as IInvoiceListContext,
);

export function useInvoiceListContext() {
  const contextData = useContext(InvoiceListContext);
  return contextData;
}
